import { createSelector } from '@reduxjs/toolkit';
import { selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { StateProps } from 'component/page/search/City/ActivitiesPOIContainer/ActivitiesPOIContainer.types';
import { PointOfInterest } from 'gql/autogen/PointOfInterest';
import { activityCardMapper } from 'component/common/ActivityCard/ActivityCard.selectors';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { ActivityPOI } from 'component/common/ActivityPOICard/ActivityPOICard.types';
import { isOn } from 'core/window/bootstrapConfig';
import { FeatureName } from 'core/constant/FeatureName';

export const mapStateToProps = createSelector(selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap, (config, featureBehaviours): StateProps => {
    const isPageContainerSpacing = isOn(FeatureName.PageContainerSpacing, config);
    return {
        config,
        isPageContainerSpacing,
    };
});

export const poiMapper = (poiReponse: PointOfInterest[], config: BootstrapConfig): ActivityPOI[] => {
    return poiReponse
        .map((poi: PointOfInterest) => {
            return {
                id: poi.id,
                name: poi.name,
                nameTranslated: poi.nameTranslated,
                imageUrl: poi.imageUrl,
                activities: activityCardMapper(poi.activities || [], config),
            } as ActivityPOI;
        })
        .filter((poi: ActivityPOI) => poi.activities.length > 0);
};
